module.exports = __webpack_public_path__ + "img/业主缴费.a5efa485.png";